var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareraisehand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#bd202d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.01,0H13.99C6.27,0,0,6.27,0,13.99V91.01c0,7.73,6.27,13.99,13.99,13.99H91.01c7.73,0,13.99-6.27,13.99-13.99V13.99c0-7.73-6.27-13.99-13.99-13.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.07,26.05c7.32-.09,13.14,5.87,13.23,13.23,.04,7.23-6.09,13.36-13.19,13.1-7.23,.22-13.32-5.91-13.23-13.14,.04-7.45,5.82-13.1,13.19-13.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.56,63.58c-.88,.53-1.1,1.15-1.1,2.07,.04,3.97,.04,7.94,0,11.95-.04,2.51-1.06,4.63-3.31,5.82-1.01,.53-2.25,.84-3.4,.84-3.88,.09-7.76,.04-11.64,.04s-7.85,.04-11.73,0c-2.51-.04-4.5-1.1-5.73-3.31-.44-.84-.79-1.85-.84-2.78-.09-3.88-.18-7.76,0-11.64,.22-4.76,3.4-9.08,8.03-10.94,2.03-.79,4.15-.97,6.31-1.01,4.85,0,9.66,.04,14.51-.04,.79,0,1.63-.22,2.29-.66,2.2-1.37,4.28-3.04,5.38-5.47,.53-1.15,.88-2.47,.88-3.7-.04-4.19-.26-8.38-.44-12.57-.09-1.94-.31-3.92-.18-5.87,.18-2.07,1.94-3.75,4.01-4.23,1.94-.44,4.28,.49,5.34,2.25,.49,.84,.88,1.81,.93,2.73,.26,6.53,.71,13.01,.62,19.45-.13,7.36-3.62,13.14-9.92,17.07Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareraisehand);
export default __webpack_public_path__ + "static/media/squareraisehand.4972ea803164ac44d02e8c5c3944a73c.svg";
export { ForwardRef as ReactComponent };